import React from 'react';
import cardData from './CardData'; 
import styles from './Card.module.css';


const Card = ({ onCardClick }) => {
  return (
    <div className={styles.cardContainer}> 
      {cardData.map((card) => (
        <div
          key={card.id}
          className={styles.cardLink} 
          onClick={() => onCardClick(card)} 
        >
          <div className={styles.card}>
          
            <div className={styles.cardImage}> 
              <img src={card.image} alt={card.title} />
            </div>

        
            <div className={styles.cardProfile}>
              {card.profilePic}
            </div>

        
            <div className={styles.cardInfo}> 
              <h3>{card.name}</h3>
              <div className={styles.tagline}>{card.tagline}</div>
              <p>{card.description}</p>

            
              <div className={styles.tags}>
                {card.tags.map((tag, index) => (
                  <span key={index} className={styles.tag}>{tag}</span>
                ))}
              </div>

              <div className={styles.financials}>
                <p>AMOUNT RAISED: {card.amountRaised}</p>
                <p>VALUATION CAP: {card.valuationCap}</p>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Card;
